import { useEffect } from "react";
import { Outlet, useLocation } from "react-router";
import { TopNavbar } from "@/com/shared/TopNavbar/TopNavbar";
import { MobileBottomNav } from "@/com/shared/MobileBottomNav/MobileBottomNav";

export default function DashboardLayout() {
	const { pathname } = useLocation();

	// Reset scroll on page change — without this, switching tabs keeps the
	// previous page's scroll offset and the new page opens mid-content.
	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return (
		<div className="min-h-screen bg-background relative">
			{/* Gradient mesh background */}
			<div className="gradient-mesh">
				<div className="gradient-mesh-blob-3" />
			</div>

			<TopNavbar />
			<main className="relative z-10 container mx-auto px-4 pt-6 pb-24 md:pb-8 max-w-6xl">
				<Outlet />
			</main>
			<MobileBottomNav />
		</div>
	);
}
